import React from 'react';

import {greyishBlue400} from "assets/jss/main";

function SidebarHeadingTitle(props) {
    return (
        <div style={{
            color: greyishBlue400,
            fontSize: '12px',
            padding: '8px'
        }}>
            {props.children}
        </div>
    );
}

export default SidebarHeadingTitle;
